<div class="w100" fxLayout="row" fxLayoutAlign="space-between center">
  <h2>{{'EMAIL_HISTORY.COMPON_MENU.ETI_PRODU_ADQUI' | translate}}</h2>
  <button mat-icon-button (click)="cerrar()" class="mr-20">
    <mat-icon class="s-20">close</mat-icon>
  </button>
</div>
<ng-container *ngIf="cargando; else datosCargados">
  <div fxLayout="column" fxLayoutAlign="start center" class="p-20">
      <p>{{'EMAIL_HISTORY.COMPON_MENU.CARG_LIST_PRODU' | translate}}</p>
      <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
  </div>
</ng-container>
<ng-template #datosCargados>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20">
      <!-- use a disabled button to provide padding for tree leaf -->
      <button mat-button class="fw400" (click)="eligeProducto(node.datosProducto)">
        <mat-icon class="mr-20">arrow_right</mat-icon>
        <ng-container *ngIf="!node.acumulable; else prodAcumulable;">
        {{node.name}} - {{node.anioProducto}}
        </ng-container>
        <ng-template #prodAcumulable>
          <ng-container *ngIf="node.consecutivo">
            Pulso {{(node.datosProducto.numPulse + 1)}}
          </ng-container>
          <ng-container *ngIf="!node.consecutivo">
            {{node.datosProducto.nameSurvey}}
          </ng-container>
        </ng-template>
      </button>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="20">
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>
      <button mat-button matTreeNodeToggle> {{'EMAIL_HISTORY.COMPON_MENU.'+node.name | translate}}</button>
    </mat-tree-node>
  </mat-tree>
</ng-template>
